import BaseModelInstance from './base.model'
import { CarrierPriority as ModelDefinition } from './model-definitions'

class CarrierPriority extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default CarrierPriority
